import script from "./DocsApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocsApp.vue?vue&type=script&lang=ts&setup=true"

import "@/css/docs.less?vue&type=style&index=0&lang=less&external"

const __exports__ = script;

export default __exports__